import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import JournalBasicInfoComponent from './jounal-basic-info.component';

export const JournalComponent = ({
  handleInnerFormChange, selectedJournals, back, handleFormSubmit, ledgersList
}: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Journal Information',
      component: <JournalBasicInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        selectedJournals={selectedJournals}
        ledgersList={ledgersList}
      />,
      isVisible: true,
    },
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default JournalComponent;
